export default __webpack_public_path__ + "static/char-v-31-zh-Hant-212aa0326672730b285e0bf7d459de2c.mp4";